/*
Get the data from the redux store,
set the countdown data from the gamepage socket listeners
room.gameFlag in redux state is false
room.countdown in redux state is initialized as -1
"countdown" sets countdown data
"reset countdown" sets coutdown to -1
"game started" sets the gameStarted flag to true
when player finishes, gameStarted flag is set back to false
work on the mix up of flags, gameEnd and GameStart
End game details
How can I tell when the game is finished?
*/
import { useSelector } from "react-redux";
import "./Countdown.scss"
export default function CountDown(){        
    const { room,countdownFlag,countdown } = useSelector(state=>state.game);
    const gameType = room.gameType;
    const countDownText = (gameType) => {
        if(gameType === "PRACTICE"){
            return "WAITING FOR COUNTDOWN....";
        }else{
            return "Looking for Players....";
        }
    }
    return (
        <div className = {`countdown ${countdownFlag? '' : 'countdown--none' }`}
        >
            <h1>
                {countdown === -1 ? countDownText(gameType) : countdown}
            </h1>
        </div>
    );
};